"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Card_1 = __importDefault(require("@material-ui/core/Card"));
const CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const axiosFactory_1 = __importDefault(require("../../services/axiosFactory"));
const ListaDocumentos_1 = __importDefault(require("./ListaDocumentos"));
const FILENAMES = {
    DEMONSTRATIVO_CET: 'DEMONSTRATIVO_CET.pdf',
    CONTRATO_CONSIGNADO: 'CONTRATO_CONSIGNADO.pdf',
    TRILHA_AUDITORIA_EMPRESTIMO: 'trilha_auditoria_emprestimo.pdf',
};
const getDocumentosConfig = ({ ehPortocred }) => [
    {
        nomeArquivo: FILENAMES.CONTRATO_CONSIGNADO,
        titulo: 'Contrato Consignado',
    },
    {
        nomeArquivo: FILENAMES.TRILHA_AUDITORIA_EMPRESTIMO,
        titulo: 'Trilha Auditoria',
    },
    ...(ehPortocred
        ? [
            {
                nomeArquivo: FILENAMES.DEMONSTRATIVO_CET,
                titulo: 'Demonstrativo CET',
            },
        ]
        : []),
];
const CardDocumentosNegociacao = ({ idPessoa, idNegociacao, statusNegociacao, ehPortocred, }) => {
    const [itensPdfs, setItensPdfs] = react_1.useState([]);
    const [loading, setLoading] = react_1.useState(true);
    const documentosConfig = getDocumentosConfig({
        idPessoa,
        idNegociacao,
        ehPortocred,
    });
    const axiosApi = react_1.useMemo(() => {
        return axiosFactory_1.default({
            baseURL: '/api',
        });
    }, []);
    const carregarLinksPdf = async () => {
        const itens = [];
        if (statusNegociacao === 'APROVADO') {
            const promises = documentosConfig.map(async (config) => {
                const { nomeArquivo, titulo } = config;
                try {
                    const { data: { link: downloadUrl }, } = await axiosApi.request({
                        url: '/negociacao/downloadArquivoNegociacao',
                        data: { nomeArquivo, idNegociacao },
                        method: 'POST',
                    });
                    if (downloadUrl) {
                        itens.push({
                            titulo: titulo,
                            onClick: () => window.open(downloadUrl),
                        });
                    }
                }
                catch (err) {
                    console.error(`Ocorreu um erro ao gerar link do pdf: ${FILENAMES.CONTRATO_CONSIGNADO}`, err);
                }
            });
            await Promise.all(promises);
        }
        setItensPdfs(itens);
        setLoading(false);
    };
    react_1.useEffect(() => {
        if (idNegociacao) {
            carregarLinksPdf();
        }
    }, [idNegociacao]); // eslint-disable-line react-hooks/exhaustive-deps
    return (react_1.default.createElement(Card_1.default, { variant: "outlined" },
        react_1.default.createElement(CardContent_1.default, null,
            react_1.default.createElement(Typography_1.default, { variant: "body1", color: "textSecondary", gutterBottom: true }, "Documentos relacionados ao seu empr\u00E9stimo"),
            loading ? (react_1.default.createElement(CircularProgress_1.default, { disableShrink: true })) : itensPdfs.length ? (react_1.default.createElement(ListaDocumentos_1.default, { itens: itensPdfs })) : (react_1.default.createElement(Typography_1.default, { variant: "body2", color: "textSecondary" }, "Nada a exibir ainda...")))));
};
exports.default = CardDocumentosNegociacao;
//# sourceMappingURL=index.js.map